import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@services/auth.service';

/** The app's entry point: opens the user's first organisation, or sends them to the client app's login. */
@Component({
    selector: 'validate',
    templateUrl: './validate.component.html',
    imports: []
})
export class ValidateComponent {
    auth = inject(AuthService);
    router = inject(Router);

    constructor() {
        this.openFirstOrganization();
    }

    private async openFirstOrganization(): Promise<void> {
        const user = await this.auth.get();
        const orgId = Object.keys(user?.organizationData ?? {})[0];
        if (user?.type === 'GLOBAL' && orgId) {
            // OrgGuard loads the organisation itself.
            await this.router.navigate(['/organizations', orgId], { replaceUrl: true });
            return;
        }
        this.auth.redirectToLogin();
    }
}
